import Presentation from "./presentation";

const UploadThumbnailSkeleton = ( { aspectRatio } ) => {
	return (
		<Presentation aspectRatio = { aspectRatio } />
	);
};

export default UploadThumbnailSkeleton;